import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useMember } from "../lib/memberAuth";

// Handles Google OAuth return for MEMBER accounts (#session_id in URL fragment)
export default function MemberOAuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setMember } = useMember();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    const intent = sessionStorage.getItem("olm_oauth_intent") || "login";
    sessionStorage.removeItem("olm_oauth_intent");
    if (!sessionId) { navigate("/account/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/members/oauth/google/session", { session_id: sessionId, intent });
        window.history.replaceState(null, "", window.location.pathname);
        setMember(data);
        if (intent === "link") { toast.success("Google connected to your account"); navigate("/account"); return; }
        if (data.created) navigate("/account?welcome=1");
        else { if (data.linked) toast.success("Google connected — signed in to your existing account"); navigate("/account"); }
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Google sign-in failed. Please try again.");
        navigate("/account/login");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-[#FAFAFA]">
      <div className="text-center">
        <Loader2 className="animate-spin text-[#E63946] mx-auto mb-3" size={32} />
        <p className="text-black/50 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
